import './site-menu-modal.js';
import './pricing-slider.js';
import './locations-slider.js';
import './reviews-slider.js';
import './counters.js';
import './site-list.js';
import './scroll-up.js';
import './feedback-modal.js';

AOS.init({
  once: true,
});
